import React from "react";
import { Col } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

const LoginUpdateNotification = () => (
  <Col
    lg={12}
    md={12}
    sm={12}
    style={{
      color: "#1f8e93",
      backgroundColor: "#eaf9fa",
      borderRadius: "3px",
      padding: "18px",
      margin: "-100px 0px 40px",
    }}
  >
    <Col
      lg={1}
      md={1}
      sm={1}
      className="d-inline-block"
      style={{ verticalAlign: "top" }}
    >
      <FontAwesome name="info-circle" size="2x" />
    </Col>
    <Col lg={10} md={10} sm={10} className="d-inline-block">
      <p className="mb-3" style={{ fontSize: "14px", fontWeight: "bold" }}>
        Notice something different?
      </p>
      <p className="mb-3" style={{ fontSize: "14px" }}>
        We've redesigned our login experience to streamline the process for you.
      </p>
    </Col>
  </Col>
);

export default LoginUpdateNotification;
